/**
 * Random product order for collection PLPs.
 *
 * Unless the shopper explicitly picks a sort (sort_by in the URL), the
 * product grid is shuffled client-side on every render. Shopify has no
 * random sort_by and caches server renders, so client-side shuffling is
 * the only way to guarantee a different order per page load.
 *
 * Three render paths are covered:
 *  1. Initial page load: inline scripts in main-collection-product-grid
 *     hide the grid while it parses, then call PlpRandomOrder.shuffleGrid
 *     and reveal it (no flash of the server order).
 *  2. facets.js filter/sort re-renders: they replace #ProductGridContainer's
 *     innerHTML; the MutationObserver below re-shuffles the fresh grid.
 *     MutationObserver callbacks are microtasks, which run before the next
 *     paint, so the server order is never visible.
 *  3. Load-more appends: plp-load-more.js shuffles each fetched batch via
 *     PlpRandomOrder.shuffleItems before appending. Batches stay in
 *     sequence so already-seen products never move.
 */
(function () {
  function shouldShuffle() {
    if (window.Shopify && window.Shopify.designMode) return false;
    return !new URLSearchParams(window.location.search).has('sort_by');
  }

  // Fisher-Yates, in place.
  function shuffleItems(items) {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  }

  function shuffleGrid(grid) {
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll(':scope > li.grid__item'));
    if (items.length < 2) return;

    shuffleItems(items);
    const fragment = document.createDocumentFragment();
    items.forEach((item) => fragment.appendChild(item));
    grid.appendChild(fragment);
  }

  window.PlpRandomOrder = { shouldShuffle, shuffleItems, shuffleGrid };

  // Re-shuffle when facets.js swaps in a freshly rendered grid. Only whole
  // container re-renders (mutation target is the container itself) count;
  // load-more appends mutate the inner <ul> and are handled by
  // plp-load-more.js so the existing order is never disturbed.
  function observeFacetRerenders() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    new MutationObserver((mutations) => {
      if (!shouldShuffle()) return;
      const rerendered = mutations.some((mutation) => mutation.target === container);
      if (rerendered) shuffleGrid(document.getElementById('product-grid'));
    }).observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeFacetRerenders);
  } else {
    observeFacetRerenders();
  }
})();
